import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfoOutline = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20.3333 33.6667C27.6971 33.6667 33.6667 27.6971 33.6667 20.3333C33.6667 12.9695 27.6971 7 20.3333 7C12.9695 7 7 12.9695 7 20.3333C7 27.6971 12.9695 33.6667 20.3333 33.6667Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.3334 19.1212V26.394",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.3336 15.4849C21.003 15.4849 21.5457 14.9422 21.5457 14.2728C21.5457 13.6033 21.003 13.0606 20.3336 13.0606C19.6641 13.0606 19.1215 13.6033 19.1215 14.2728C19.1215 14.9422 19.6641 15.4849 20.3336 15.4849Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgInfoOutline);
export default ForwardRef;
